import { LitElement, html, svg } from 'lit';

export class IconMessage32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Snakkeboble</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M29 25H15l-8 6v-6H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h26a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2ZM7 7h18M7 13h9.5M7 19h5.5"></path></svg>`; }
}
if (!customElements.get('f-icon-message32', IconMessage32)) {
  customElements.define('f-icon-message32', IconMessage32);
}